module.exports = __webpack_public_path__ + "static/media/unternehmen-online.0cd2639c.jpg";